'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/ECFront'

import HomeHighlightSlider from '../../Components/Home/HomeHighlightSlider'
import HolidaysMessage     from '@/HolidaysMessage'
import HomeAdSlider        from '@/Home/HomeAdSlider'

const types_i18n =
{
	show_product: 'Spectacle',
	parc_product: 'Parc d\'attraction',
	default: 'Billet'
};

let app = window.app;

export default class NewContentPage extends Component
{
	state =
	{
		ad_articles: [],
		role: app.state.session?.permissions?.title
	};

	UNSAFE_componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		if (app.state.session.permissions?.title)
		{
			component.setState({ role: app.state.session.permissions.title });
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = ({ source, data }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ role: app.state.session.permissions?.title });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const output =
		(
			<Layout history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					{
						state.role ?
						(
							<HomeAdSlider force role={ state.role } />
						)
						: undefined
					}

					{
						state.role ?
						(
							<HomeHighlightSlider force role={ state.role } />
						)
						: undefined
					}

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}